import { SeoPage } from 'libs/shared-lib/interfaces';
export const NOT_FOUND_SEO_FR: SeoPage = {
    title: '404',
    description: "La page que vous recherchez n'est plus disponible.",
    image: '',
    twitter: {
        card: 'summary',
        title: '404',
        description: "La page que vous recherchez n'est plus disponible.",
    },
    og: {
        title: '404',
        description: "La page que vous recherchez n'est plus disponible.",
    },
    robots: {
        noIndex: true,
        noFollow: true,
    },
};
